const APP_WIDTH = '750px';

export {
    APP_WIDTH
}